import React, { Component } from 'react';
import { message } from 'antd';
import MachineRepairsListView from '../views/MachineRepairsListView';
import { base } from '../../base';

class MachineRepairsListContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            repairs: [],
        };
    }

    handleLogDelete = (id) => {
        console.log(id);
        const extraUser = this.props.extraUser;
        base.remove(`repairs/${this.props.extraUser.companyid}/${id}`, function (err) {
            if (!err) {
                message.success('Reparación Eliminada');
            }
        });
    }

    componentWillMount() {
        this.valuesRef = base.syncState(`repairs/${this.props.extraUser.companyid}/`, {
            context: this,
            state: 'repairs',
            asArray: true,
            queries: {
                orderByChild: 'machineid',
                equalTo: this.props.machineId,
            },
        });
    }

    componentWillUnmount() {
        base.removeBinding(this.valuesRef);
    }

    render() {
        console.log(this.state.repairs);
        return (
            <MachineRepairsListView
                deleteLog={this.handleLogDelete}
                machineId={this.props.machineId}
                user={this.props.user}
                extraUser={this.props.extraUser}
                repairs={this.state.repairs}
            />
        );
    }
}
export default MachineRepairsListContainer;



// WEBPACK FOOTER //
// ./src/components/containers/MachineRepairsListContainers.js